import React, { createContext, useContext } from 'react';

interface FormChangeContextType {
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
  resetFormState: () => void;
}

export const FormChangeContext = createContext<FormChangeContextType | undefined>(undefined);

export const useFormChange = () => {
  const context = useContext(FormChangeContext);
  if (!context) {
    throw new Error('useFormChange must be used within a FormChangeProvider');
  }
  return context;
};
